module.exports = __webpack_public_path__ + "static/media/cv3.318ba12c.jpg";